import SlideCopy from '@/components-v2/common/slide-copy/SlideCopy.vue'

export default {
  extends: SlideCopy,
  props: {
    presentationId: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  async mounted() {
    await this.getData()
  },
  methods: {
    async getData() {
      this.isLoading = true
      this.$emit('onLoading')
      await this.loadData()
      this.isLoading = false
      this.$emit('onLoaded')
    },
    // Only need to override this method
    async loadData() {
      // get presentations or folder in here
      return Promise.resolve([])
    },
    handlePresentationItemClick(presentation) {
      this.$emit('handlePresentationItemClick', presentation)
    },
  },
}
